import React from "react";
//import axios from 'axios';
import './OTPCheck.css';

//import AuthService from '../Services/auth.service';
class OTPCheck extends React.Component {

constructor(){
    super();
    this.state = {
        cats : [],
    }
  // this.signUp = this.signUp.bind(this);
}
async pinResult(e, keyword){
 
  if(keyword.length === 4){
    
    this.props.updateState(this.otp)
  

  }
  
  
}

  render() {
    return <div>

                <div className="container  ">


                  <div className="   pt-5 pb-5 center-space">
                    <div className="text-center">
                    <a className="" href="/#">  <img src="/assets/images/logo/logo.jpg" alt="" title="" className="img-fluid mb-2 popup-img" /> </a>
                    {/* <a className="" href="/#"> <img src="/assets/images/logo/logo-3.png" alt="" title="" className="img-fluid buy-otp-img" /> </a> */}
                    </div>
                            <div className="row-form  mt-3 center-space pl-1 mb-5 my-otp">
                                        <h6 className="green-label">Enter OTP</h6>
                                        <input className="form-controls " type="text" placeholder="" id="example-email-input" maxLength="4" onChange={e => {this.otp = e.target.value; this.pinResult(e, e.target.value)}}/>
                                        <p class={this.props.msgClass}>{this.props.msg}</p>

                                        <a href="/#" className="sub-tag" onClick={() => this.props.handleNoChange()}>Change Mobile Number</a> <br></br>
                                        <a href="/#" className="sub-tag">Resend OTP</a>
                                        </div> 
                                        <div className="text-center ">
                                              <button type="button" className=" add-to-cart2 btnn " id="the_otp" onClick={() => this.props.updateState(this.otp)}>Enter</button><br/>
                                              <button type="button" className="  btnn  btn-outline-green" onClick={() => this.props.handleCancel('false')}>Cancel</button></div>
                                        </div>
                </div>
    </div>
    }
}

export default OTPCheck;
